import { createServerFn } from "@tanstack/react-start";

export const getHomeContent = createServerFn({ method: "GET" }).handler(async () => {
  const { loadHomeContent } = await import("./home-content.server");
  return loadHomeContent();
});

export type { FeaturedProject, HomeContent } from "./home-content.server";
